import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BadInputError, Result, ValueObject } from '@digibricks/core';
import { TimeUnit } from '../time-unit';

/** Shared implementation for duration value objects with distinct domain names. */
export var Duration = /*#__PURE__*/function (_ValueObject) {
  _inherits(Duration, _ValueObject);

  var _super = _createSuper(Duration);

  function Duration() {
    _classCallCheck(this, Duration);

    return _super.apply(this, arguments);
  }

  _createClass(Duration, [{
    key: "value",
    get: function get() {
      return this.props.value;
    }
  }, {
    key: "unit",
    get: function get() {
      return this.props.unit;
    }
  }, {
    key: "toTotalSeconds",
    value: function toTotalSeconds() {
      return TimeUnit.toTotalSeconds(this.props.value, this.props.unit);
    }
  }, {
    key: "formatLabel",
    value: function formatLabel() {
      return TimeUnit.formatLabel(this.props.value, this.props.unit);
    }
  }], [{
    key: "createDuration",
    value: function createDuration(value, unit, minValue, invalidValueMessage, create) {
      if (!Number.isFinite(value) || value < minValue) {
        return new BadInputError(invalidValueMessage);
      }

      if (!TimeUnit.isSecond(unit) && !TimeUnit.isMinute(unit)) {
        return new BadInputError("Unsupported time unit: ".concat(unit));
      }

      return Result.ok(create({
        value: value,
        unit: unit
      }));
    }
  }]);

  return Duration;
}(ValueObject);